<template>
  <div
    class="formCheckboxList"
    :class="{
      'formCheckboxList--collapseActive': collapse,
      'formCheckboxList--mobileCollapse': mobileCollapse,
    }"
  >
    <div
      class="formCheckboxList__label"
      :class="{ 'formCheckboxList__label--mobileCollapse': mobileCollapse }"
      @click="toggleCollapse"
    >
      {{ label }}
    </div>
    <div
      ref="formCheckboxList"
      class="formCheckboxList__list"
      :class="{ 'formCheckboxList__list--mobileCollapse': mobileCollapse }"
    >
      <form-checkbox
        v-for="(checkbox, index) in options"
        :id="id + '_' + checkbox.value"
        :key="checkbox.value"
        v-model="values"
        :name="id + '_' + checkbox.value"
        :value="checkbox.value"
        :class="{
          'formCheckboxList__list--hide': collapseCount && index > collapseCount + 1 && !more.show,
        }"
        :label="checkbox.label"
        :available="checkbox.available"
        @change="onChange"
      />
    </div>
    <button
      v-if="options.length > collapseCount + 2"
      class="formCheckboxList__button"
      :class="{ 'formCheckboxList__button--mobileCollapse': mobileCollapse }"
      @click="toggle"
    >
      {{ more.text }}
    </button>
  </div>
</template>

<script>
import FormCheckbox from './FormCheckbox';

export default {
  name: 'FormCheckboxList',
  components: {
    formCheckbox: FormCheckbox,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: undefined,
    },
    collapseCount: {
      type: Number,
      default: undefined,
    },
    mobileCollapse: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => {},
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [Object, Array, String],
      default: () => {},
    },
  },
  data() {
    return {
      values: [],
      more: {
        show: false,
        text: 'Pokaż wszystkie',
      },
      collapse: false,
    };
  },
  watch: {
    value: {
      handler(value) {
        if (this.value) {
          this.values = value;
        } else {
          this.values = [];
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.value) {
      this.values = this.value;
    }
  },
  methods: {
    toggle() {
      if (this.more.show) {
        this.more.show = false;
        this.more.text = 'Pokaż wszystkie';
      } else {
        this.more.show = true;
        this.more.text = 'Pokaż mniej';
      }
    },
    toggleCollapse() {
      if (this.collapse) {
        this.collapse = false;
        this.$refs.formCheckboxList.style.maxHeight = '';
      } else {
        this.collapse = true;
        this.$refs.formCheckboxList.style.maxHeight = `${this.$refs.formCheckboxList.scrollHeight}px`;
      }
    },
    onChange(value) {
      this.$emit('input', value);
      this.$emit('emitObject', { name: this.name, value });
    },
  },
};
</script>

<style lang="scss">
.formCheckboxList {
  $root: &;
  transition: padding $tr;

  &--mobileCollapse {
    @include rwd('large-tablet') {
      border-bottom: 1px solid $cAddLight;
    }
  }

  &--collapseActive {
    padding-bottom: 2rem;

    #{$root}__label {
      &:after {
        transform: rotate(180deg);
      }
    }
  }

  &__label {
    margin-bottom: 1.1rem;
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 600;
    color: $cMainDark;

    &--mobileCollapse {
      @include rwd('large-tablet') {
        display: flex;
        justify-content: space-between;
        padding: 1.8rem 0 1rem;

        &:after {
          @include icomoon('chevron-down');
          color: $cMainLight;
          font-size: 0.8rem;
          transition: transform $tr;
        }
      }
    }
  }

  &__list {
    &--hide {
      display: none;
    }

    &--mobileCollapse {
      @include rwd('large-tablet') {
        max-height: 0;
        overflow: hidden;
        transition: max-height $tr;

        #{$root}__list--hide {
          display: block;
        }
      }
    }
  }

  &__button {
    margin-top: 0.6rem;
    font-size: 1.3rem;
    line-height: 2rem;
    color: $cMain;
    text-decoration: underline;
    transition: color $tr;

    &:hover {
      color: $cSec;
    }

    &--mobileCollapse {
      @include rwd('large-tablet') {
        display: none;
      }
    }
  }
}
</style>
